import React from 'react'
import './FestivalWinnerGiftComponent.css'
import { Apiurl } from '../../Pages/utils/page';
import { useNavigate } from 'react-router-dom';

const FestivalWinnerGiftComponent = ({ winnerData, winnerWithPorduct }) => {
    const navigate = useNavigate();
    return (
        <div style={{ flex: "1" }}>
            <div className="banner_section" >
                <div><div className="container" >
                    {/* {winnerData?.length ?

                        <div className="festival_winneer_wraper">
                            {winnerData?.map((winner, index) => {
                                return (
                                    <div className="winners-cards-wraper" key={index}>
                                        <div className="row">
                                            <div className="col-lg-12">
                                                <div className="row">
                                                    <div className="col-lg-3">
                                                        <div className="step_position">
                                                            <div className="festi_position_wraper">
                                                                <h4>Position {winner.Position}</h4>
                                                                <button
                                                                    className="festi_cliam_btn common_btn_new festi_disable_cliam_btn"
                                                                    disabled={true}
                                                                >
                                                                    Not Eligible
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-9">
                                                        <div className="row">
                                                            <div className="col-lg-12" >
                                                                <div className="festival_wiiners_products" >
                                                                    {winner?.Products?.map((product, productIndex) => {
                                                                        const img = product?.imageSrc.split('"')
                                                                        const imgUrl = `${Apiurl()}/${img?.[1]}`
                                                                        return (
                                                                            <div className="festival_bg" key={productIndex}>
                                                                                <div className="row">
                                                                                    <div className="col-lg-3">
                                                                                        <img
                                                                                            src={imgUrl}
                                                                                            className="w-100"
                                                                                        />
                                                                                    </div>
                                                                                    <div className="col-lg-9">
                                                                                        <div className="row">
                                                                                            <div className="col-lg-6">
                                                                                                <h2>{product.Name}</h2>
                                                                                                <p>{product.Description}</p>
                                                                                            </div>
                                                                                            <div className="col-lg-3">
                                                                                                <div className="festi_price_web">
                                                                                                    <h2>MRP</h2>
                                                                                                    <p>
                                                                                                        <span className="event_mrp">
                                                                                                            ₹ {product.Mrp}
                                                                                                        </span>
                                                                                                    </p>
                                                                                                </div>
                                                                                            </div>
                                                                                            <div className="col-lg-3">
                                                                                                <div className="festi_price_web">
                                                                                                    <h2>Free Gift</h2>
                                                                                                    <p>
                                                                                                        <span>
                                                                                                            ₹ "0"
                                                                                                        </span>
                                                                                                    </p>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        );
                                                                    })}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}



                        </div>
                         : */}

                    <div className="customer_not_eligible" >
                        <div className="row" >

                            <div className="col-lg-4 col-sm-7 col-12 mr-auto ml-auto" >
                                <div className="not_eligible_wraper" ><div >
                                    <h2 >Apologies, you are not selected as a lucky winner.</h2>
                                    <p >Best of luck for next time</p>
                                    <div className="go_back_not_eligible" >
                                        <input type="button" onClick={() => navigate("/")} value="Continue shopping" className="common_btn_new bid_now_btn_01" />
                                    </div></div></div></div></div>
                    </div>

                    {/* } */}

                    <div className="winners_gift_list">
                        <div className="row">
                            <div className="col-lg-12">
                                <h4 className="common_heading text-center event_head_txt">Event Winners List</h4>
                            </div>
                        </div>
                        <div className="row">
                            {winnerWithPorduct?.flatMap((item) =>
                                item?.Products?.map((product) => {
                                    // Define bannerUrl outside of the JSX
                                    const banner = product?.imageSrc?.split('"');
                                    const bannerUrl = banner?.[3] ? `${Apiurl()}/${banner[3]}` : '';

                                    return (
                                        <div key={product?.Id} className="col-lg-4 col-md-4 col-12 event_warper_box_spc">
                                            {/* Product Image */}
                                            <div className="wiiner_event_img">
                                                <img
                                                    src={bannerUrl}
                                                    className="w-100"
                                                    alt={product?.Name}
                                                />
                                            </div>

                                            {/* Position and User Information */}
                                            <div className="winner_event_list_wraper">
                                                <h5>{item?.Position} Position</h5>
                                                <div className="winner_event_align_middle">
                                                    <img
                                                        src="https://elitedeal.elitewebdemo.com/image/unisexImage.jpeg"
                                                        alt="User"
                                                    />
                                                    <div className="winner_name_display_win">
                                                        <p className="mb-0">{item?.Users?.[0]?.Name}</p>
                                                    </div>
                                                </div>
                                                {/* <p className="product_name">{product?.Name}</p>
                                                <p>MRP: {product?.Mrp}</p> */}
                                            </div>
                                        </div>
                                    );
                                })
                            )}


                        </div>
                    </div>
                </div>



                </div></div>

        </div >
    )
}

export default FestivalWinnerGiftComponent
